module.exports = __webpack_public_path__ + "img/mz.b1a76f11.svg";